import React from 'react';
import SystemStatus from './systemStatus';

const SystemsList = (props) => {

    if (!props.show) {
        return null;
    }

    return (
        <div className='systems-status-sync-list-container' onClick={() => props.onClose()}>
            <div onClick={e => e.stopPropagation()} className='status-container'>
                <div className='system-status-container'>   
                    {props.systemsAccounts.map(x => <div>
                        <SystemStatus
                            key={x.id}
                            system={x} />
                    </div>)}
                </div>
            </div>
        </div>
    );
};

export default SystemsList;